import { Inbox, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon = Inbox, title, description, action, onAction, className, testId }) => (
  <div className={cn("flex flex-col items-center justify-center rounded-lg border border-dashed border-border px-6 py-10 text-center", className)} data-testid={testId}>
    <Icon className="h-5 w-5 text-muted-foreground/70" strokeWidth={1.75} aria-hidden="true" />
    <p className="mt-3 text-[13px] font-medium">{title}</p>
    {description ? <p className="mt-1 max-w-sm text-xs leading-relaxed text-muted-foreground">{description}</p> : null}
    {action ? (
      <Button size="sm" variant="outline" className="mt-4" onClick={onAction} data-testid={testId ? `${testId}-action` : undefined}>
        {action}
      </Button>
    ) : null}
  </div>
);

export const ErrorState = ({ message = "Kunne ikke hente data.", onRetry, className, testId }) => (
  <div className={cn("flex flex-col items-center justify-center rounded-lg border border-destructive/30 px-6 py-8 text-center", className)} data-testid={testId} role="alert">
    <p className="text-[13px] font-medium text-destructive">{message}</p>
    {onRetry ? (
      <Button size="sm" variant="outline" className="mt-4 gap-1.5" onClick={onRetry} data-testid={testId ? `${testId}-retry` : undefined}>
        <RefreshCw className="h-3.5 w-3.5" aria-hidden="true" /> Prøv igjen
      </Button>
    ) : null}
  </div>
);
